import { Component,Input, OnInit } from '@angular/core';
import { ProductService } from 'src/app/service/product.service';
//import category_data from 'src/app/shared/data/category-data';
//import { UtilsService } from 'src/app/shared/services/utils.service';
//import { ICategoryType } from 'src/app/shared/types/category-d-t';

@Component({
  selector: 'app-shop-category',
  templateUrl: './shop-category.component.html',
  styleUrls: ['./shop-category.component.scss']
})
export class ShopCategoryComponent implements OnInit {
  @Input() style_2:Boolean = false;
  @Input() style_3:Boolean = false;
  @Input() style_4:Boolean = false;
  @Input() shop_category_2:Boolean = false;
  //public category_data:ICategoryType[] = category_data;

  category_data:any = null;
  imagePath:any = null;

  constructor(
    //public utilsService:UtilsService,
    private productService: ProductService,
  ){}

  ngOnInit() {
    this.getCategoryData();
  }

  getCategoryData(){
    this.productService.productCategorys().subscribe({
      next:(res:any) => {
        if(res.status){
          console.log(res.categories);
          this.category_data = res.categories;
          this.imagePath = res.path;
        }
      },
    })
  }
}
